import {
    Component, inject
} from "@angular/core";
import {
    MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose
} from "@angular/material/dialog";

import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import {
    MatList, MatListItem, MatListItemAvatar
} from "@angular/material/list";
import { CommonModule } from "@angular/common";
import { IConfirmationDialogData } from "../../interfaces/confirmation-dialog-data";
import { ButtonDirective } from "../../../application/directives/button/button.directive";

/**
 * This is the dialog that appears to the get user confirmation
 *
 * Used by the notification service
 */
@Component({
    selector: "mgd-confirmation-dialog",
    templateUrl: "./confirmation-dialog.component.html",
    styleUrls: ["./confirmation-dialog.component.scss"],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatList,
        MatListItem,
        MatListItemAvatar,
        CommonModule,
        ButtonDirective
    ]
})
export class ConfirmationDialogComponent {

    readonly data = inject(MAT_DIALOG_DATA) as IConfirmationDialogData;
    private readonly _dialogRef = inject(MatDialogRef) as MatDialogRef<ConfirmationDialogComponent, boolean>;

    /**
     * Called when the user confirms
     */
    onConfirmClick(): void {

        this._dialogRef.close(true);
    }
}
